import check from '@/core/helpers/check';
import 'bootstrap/dist/css/bootstrap.css';
import { createApp } from 'vue';
import VueGtag from 'vue-gtag';
import App from './App.vue';
import router from './core/router';

import { toRem } from '@nxtpeople/nxt-vue-library';
import mitt, { Emitter } from 'mitt';
import { setupDirectives } from './core/helpers/directives.helper';
import { initSentry } from './core/helpers/sentry.helper';
import store from './core/store';
import i18n from './i18n';
import './registerServiceWorker';

export const bus: Emitter<any> = mitt();

const app = createApp(App);

initSentry(app, router);

if (!check.isTestEnvironment()) {
   app.use(
      VueGtag,
      {
         config: { id: 'UA-151676357-3' },
      },
      router,
   );
}

app.use(router);
app.use(store);
app.use(i18n);
setupDirectives(app);
app.config.globalProperties.$toRem = (px: number) => toRem(px, 14);

app.mount('#app');

